import BodyText from 'LuxKit/Typography/BodyText'
import { useContext } from 'react'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import TextLink from 'LuxKit/TextLink'
import ContactContext from 'contexts/contactContext'
import { useIntl } from 'react-intl'

interface Props {
  useLinkButton?: boolean
}

function CruiseSoldoutStillInterested(props: Props) {
  const { useLinkButton } = props
  const currentContact = useContext(ContactContext)
  const contact = currentContact.defaultContact
  const intl = useIntl()

  return <Group direction="vertical" gap={12}>
    <div>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'ybUz_4Hyfq3uXJeCvolT',
          defaultMessage: 'Still interested?',
        })}
      </BodyText>
      <Group direction="horizontal" gap={12}>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: '9ZUyEoQf4iPxCjxqIm2z',
            defaultMessage: 'Call us to be added to the waitlist',
          })}
        </BodyText>

        {useLinkButton && <TextLink
          startIcon={<LinePhoneIcon />}
          size="medium"
          href={`tel:${contact.number}`}
        >
          {contact.humanReadable}
        </TextLink>}
      </Group>
    </div>

    {!useLinkButton && <TextButton
      kind="primary"
      href={`tel:${contact.number}`}
      startIcon={<LinePhoneIcon />}
    >
      {intl.formatMessage({
        id: 'a0F4wGJBYzUBPoXxSuCH',
        defaultMessage: 'Call {phoneNumber}',
      }, { phoneNumber: contact.humanReadable })}
    </TextButton>}
  </Group>
}

export default CruiseSoldoutStillInterested
